import { render, staticRenderFns } from "./ExpressTag.vue?vue&type=template&id=46357749&scoped=true&lang=pug"
import script from "./ExpressTag.vue?vue&type=script&lang=js"
export * from "./ExpressTag.vue?vue&type=script&lang=js"
import style0 from "./ExpressTag.vue?vue&type=style&index=0&id=46357749&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46357749",
  null
  
)

export default component.exports